import React, { useState } from 'react'
import { isToday, format, getDate, getDay, eachDayOfInterval, endOfWeek, eachWeekOfInterval, addMonths, subMonths, startOfMonth, endOfMonth, differenceInDays, getMonth, startOfWeek } from 'date-fns';
import { Button, Label } from 'semantic-ui-react'

function Calendar({ month, dates, onSelectDate, onChangeMonth }) {
    const weekStartsOn = 1;
    const weekStarts = eachWeekOfInterval(
        { start: startOfMonth(month), end: endOfMonth(month) },
        { weekStartsOn }
    );
    const calendar = weekStarts.map(weekStart =>
        eachDayOfInterval({
            start: startOfWeek(weekStart, { weekStartsOn }),
            end: endOfWeek(weekStart, { weekStartsOn })
        })
    );

    const [selectedDate, setSelectedDate] = useState(null);

    const sundayColor = "red";
    const saturdayColor = "steelblue";
    const getDayColor = (date) => {
        const day = getDay(date);
        if (day === 0) {
            return sundayColor;
        } else if (day === 6) {
            return saturdayColor;
        } else {
            return null;
        }
    }

    const handleSelectDate = (date) => {
        setSelectedDate(date);
        onSelectDate(date);
    }

    return (
        <div>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "0.5em" }}>
                <Button onClick={() => { setSelectedDate(null); onChangeMonth(subMonths(month, 1)) }}>＜</Button>
                <span style={{ fontWeight: "bold", fontSize: "1.2em" }}>{format(month, 'y年M月')}</span>
                <Button onClick={() => { setSelectedDate(null); onChangeMonth(addMonths(month, 1)) }}>＞</Button>
            </div>
            <table style={{ width: "100%", tableLayout: "fixed" }}>
                <thead>
                    <tr>
                        <th>月</th><th>火</th><th>水</th><th>木</th><th>金</th><th style={{ color: saturdayColor }}>土</th><th style={{ color: sundayColor }}>日</th>
                    </tr>
                </thead>
                <tbody>
                    {calendar.map((weekRow, rowNum) => (
                        <tr key={rowNum}>
                            {weekRow.map(date => (
                                <td key={getDay(date)} style={{ padding: "0.5em", textAlign: "center" }}>
                                    {getMonth(month) === getMonth(date) &&
                                        <div>
                                            {dates.some(d => differenceInDays(d, date) === 0) ?
                                                <Label as="a" size="large" circular color={differenceInDays(selectedDate, date) === 0 ? "green" : "olive"} onClick={() => { handleSelectDate(date); }}>{getDate(date)}</Label>
                                                :
                                                <span style={{ display: "inline-block", padding: "0.2em", backgroundColor: isToday(date) ? "yellow" : null }}>{getDate(date)}</span>
                                            }
                                        </div>
                                    }
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default Calendar